module.exports = __webpack_public_path__ + "d5c40f0a093c7542a01658f0263eb3c1.MP3";